/** @class ItemPermissionsContainer
 *
 * @desc
 * Container to display information about the status of requested item permissions and option to request if permitted.
 *
 * @todo Wire up the following with v2 resources:
 *.   - Item permission status (client deceased Information)
 */

import {connect} from 'react-redux'
import {createResource, updateResource} from 'redux-json-api'
import {Map} from 'immutable'
import PropTypes from 'prop-types'

import {currentUserConfig} from '../../../../lib/userTools'

import FirmUserItemPermissionsContainer from './firm_user/FirmUserItemPermissionsContainer'
import QuarterbackItemPermissionsContainer from './quarterback/QuarterbackItemPermissionsContainer'

const ItemPermissionsContainer = props => {
  if (props.userConfig.get('quarterback'))
    return <QuarterbackItemPermissionsContainer {...props} />

  return <FirmUserItemPermissionsContainer data-testid='firm-user-item-permissions-container' {...props} />
}

ItemPermissionsContainer.propTypes = {
  userConfig: PropTypes.instanceOf(Map).isRequired
}

const mapStateToProps = ({api}, ownProps) => {
  const userConfig = currentUserConfig(api)

  return ({
    userConfig,
    ...ownProps
  })
}

export default connect(mapStateToProps, {createResource, updateResource})(ItemPermissionsContainer)
